<template>
  <div class="card shadow-sm">
    <div class="card-body pt-3">
      <h5>
        <strong>{{ data.header }}</strong>
      </h5>
      <p>{{ data.content }}</p>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div>
          <h6>GEOGRAPHY</h6>
          <p>{{ data.location }}</p>
        </div>
        <div>
          <h6>TIME&nbsp;PERIOD</h6>
          <p>{{ data.period }}</p>
        </div>
      </div>
      <router-link :to="data.link" class="btn btn-dark w-100"
        >Preview</router-link
      >
    </div>
  </div>
</template>

<script lang="js">

export default {
  name: "SubCard",
  data() {
    return {
    };
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        title: "",
        content: "",
        location: "",
        period: "",
        link: "",
      }),
    },
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
div.card {
  div.card-body {
    background-color: #f7f6f6;
    p {
      font-size: 0.9rem;
      line-height: 1.2rem;
    }
  }
  div.card-footer {
    font-size: 0.8rem;
    background-color: #ffffff;
    h6 {
      font-size: 0.7rem;
      font-weight: 400;
      color: blue;
      margin-bottom: 0.1rem;
    }
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
